import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
   ALL_COLLEGE_DETAILS_LIST_START: "ALL_COLLEGE_DETAILS_LIST_START",
   ALL_COLLEGE_DETAILS_LIST_SUCCESS: "ALL_COLLEGE_DETAILS_LIST_SUCCESS",
   ALL_COLLEGE_DETAILS_LIST_FAILED: "ALL_COLLEGE_DETAILS_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const allCollegeDetailsListStart = (data) => ({
    type: actionType.ALL_COLLEGE_DETAILS_LIST_START,
    payload: data,
});

export const allCollegeDetailsListSuccess = (data) => ({
    type: actionType.ALL_COLLEGE_DETAILS_LIST_SUCCESS,
    payload: data,
});

export const allCollegeDetailsListFailed = (data) => ({
    type: actionType.ALL_COLLEGE_DETAILS_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function allCollegeDetailsListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.ALL_COLLEGE_DETAILS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.ALL_COLLEGE_DETAILS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.ALL_COLLEGE_DETAILS_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* allCollegeDetailsListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allcommitmentType =  response.data.data.allColleges.Colleges
            yield put(allCollegeDetailsListSuccess(allcommitmentType));
            if(action.payload.nextScreen) action.payload.nextScreen();
        } else {
            messagePopup("", "State List failed", "error");
            yield put(allCollegeDetailsListFailed("GPA List failed"));
        }
    } catch (error) {
        messagePopup("", "State List failed", "error");
        yield put(allCollegeDetailsListFailed("State List failed"));
    }
}

export function* watchAllCollegeDetailsListSaga() {
    yield takeEvery(actionType.ALL_COLLEGE_DETAILS_LIST_START, allCollegeDetailsListSaga);
}
